import styled from 'styled-components';

export const MemberEmail = styled.p`
  width: 15rem;
  fontsize: 14px;
  textoverflow: ellipsis;
  overflow: hidden;
  whitespace: nowrap;
`;
